import QuizChallengeCreator from "./QuizChallengeCreator";

export default QuizChallengeCreator;
